import { render } from "./UnitsArea.vue?vue&type=template&id=fc6cefc6&scoped=true"
import script from "./UnitsArea.vue?vue&type=script&lang=js"
export * from "./UnitsArea.vue?vue&type=script&lang=js"

import "./UnitsArea.vue?vue&type=style&index=0&id=fc6cefc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6cefc6"]])

export default __exports__